<template>
  <div class="flex flex-col justify-between vacancy">
    <div class="vacancy__content">
      <h1 v-if="position" class="vacancy__title text-32px font-bold text-center lg:text-2xl sm:text-xl">
        {{position.name}}
      </h1>
      <div v-if="position && position.description" v-html="position.description" class="vacancy__description text-left">
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'VacancyInfo',
  props: {
    position: {
      type: Object,
      default: () => ({}),
    },
    office: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      vacancy: {
        title: 'Кладовщик (6305 г. Череповец, ТЦ "Июнь", ул. Годовикова, д.37)',
        description: `Все что от тебя нужно - это принимать товар, подготавливать его к продажам.
        И конечно, поддерживать порядок на складе и участвовать в рабочих процессах магазина.
        Ты проявляешь интерес к спорту и здоровому образу жизни, любознателен и стремишься к новым знаниям?
        Пройди собеседование прямо сейчас!
        Все очень просто: тебе нужно зарегистрироваться и записать короткое видео.
        Это позволит не тратить время на дорогу в наш офис. После регистрации нажми кнопку "Начать".
        Запись видео не начнётся без твоего согласия.
        `,
      },
    };
  },
};
</script>
<style lang="scss">
.vacancy {
  & .vacancy__poster {
    width: 60%;
    height: 420px;
    object-fit: cover;
    margin: 0 auto;

    @media(max-width: 992px) {
      height: 220px;
    }

    @media(max-width: 480px) {
      height: 190px;
    }
  }

  & .vacancy__content {
    @media (max-width: 640px) {
      padding-left: 10px;
      padding-right: 10px;
      padding-bottom: 8px;
    }
  }

  & .vacancy__title {
    color: #262626;
    word-break: break-word;
  }

  & .vacancy__description {
    margin-top: 40px;
    color: #5B5B5B;

    @media (max-width: 1200px) {
      margin-top: 24px;
    }
  }

  & .vacancy__item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px 35px;
    background: #F3F6FE;
    max-width: 400px;
    width: 100%;
  }
}
</style>
